function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-underscore-dangle */
import axios, { CancelToken } from 'axios';
import qs from 'qs';
import environment from "./environment";
import notifications from "./notifications";
import security from "./security";
import logger from "./logger";
import { t } from "./translator";
export default {
  show_notifier: true,

  /**
   * Canceller is used to cancel current requests
   *
   * @private
   *
   * @Type {object}
   */
  _canceller: CancelToken.source(),

  /**
   * Make GET request
   *
   * @param {string}  url
   * @param {?object} param
   * @param {?object} config
   *
   * @return {Promise}
   */
  get: function get(url, param, config) {
    return this.request('GET', url, param, null, config);
  },

  /**
   * Make PATCH request
   *
   * @param {string}  url
   * @param {object}  data
   * @param {?object} param
   * @param {?object} config
   *
   * @return {Promise}
   */
  patch: function patch(url, data, param, config) {
    return this.request('PATCH', url, param, data, config);
  },

  /**
   * Make PUT request
   *
   * @param {string}  url
   * @param {object}  data
   * @param {?object} param
   * @param {?object} config
   *
   * @return {Promise}
   */
  put: function put(url, data, param, config) {
    return this.request('PUT', url, param, data, config);
  },

  /**
   * Make POST request
   *
   * @param {string}  url
   * @param {object}  data
   * @param {?object} param
   * @param {?object} config
   *
   * @return {Promise}
   */
  post: function post(url, data, param, config) {
    return this.request('POST', url, param, data, config);
  },

  /**
   * Make DELETE request
   *
   * @param {string}  url
   * @param {?object} config
   *
   * @return {Promise}
   */
  delete: function _delete(url, config) {
    return this.request('DELETE', url, null, null, config);
  },

  /**
   * Perform an api request
   *
   * @param {string}  method
   * @param {string}  url
   * @param {?object} param
   * @param {object}  data
   * @param {?object} config
   *
   * @return {Promise}
   */
  request: function request(method, url, param, data, config) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this._checkCredentials().then(function () {
        axios.request(_objectSpread(_objectSpread({}, _this._buildParams(method, url, param, data)), config)).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          if (axios.isCancel(error)) {
            return;
          }

          if (!config || false !== config.notify) {
            _this._handleError(error);
          }

          reject(error);
        });
      });
    });
  },

  /**
   * Cancel all current requests
   */
  cancel: function cancel() {
    this._canceller.cancel();

    this._canceller = CancelToken.source();
  },

  /**
   * Build base request params
   *
   * @private
   *
   * @param {string}  method
   * @param {string}  url
   * @param {?object} params
   * @param {?object} data
   *
   * @return {object}
   */
  _buildParams: function _buildParams(method, url, params, data) {
    var config = {
      method: method,
      url: url,
      params: params,
      data: data,
      baseURL: environment.get('api_url'),
      headers: {
        'Content-Type': 'application/ld+json'
      },
      paramsSerializer: function paramsSerializer(params) {
        return qs.stringify(params, {
          arrayFormat: 'brackets',
          encode: false
        });
      },
      cancelToken: this._canceller.token
    };

    if (security.isAuthenticated()) {
      config.headers.Authorization = "Bearer ".concat(security.token);
    }

    return config;
  },

  /**
   * Check token and refresh token validity
   * Refresh them if it's still possible
   *
   * @private
   *
   * @return {Promise}
   */
  _checkCredentials: function _checkCredentials() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      if (!security.isAuthenticated() || !security.isTokenExpired()) {
        return resolve();
      }

      if (security.isRefreshTokenExpired()) {
        _this2._handleExpiredCredentials();

        return reject();
      }

      var request = axios({
        url: environment.get('api_url') + '/refresh_token',
        method: 'POST',
        data: {
          refresh_token: security.refreshToken
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
      request.then(function (_ref) {
        var data = _ref.data;
        security.authenticate(data.token, data.refresh_token);
        resolve();
      }).catch(function () {
        // Unable to get refresh token
        _this2._handleExpiredCredentials();

        reject();
      });
    });
  },

  /**
   * Handle basic api errors
   *
   * @private
   *
   * @param {object} error
   */
  _handleError: function _handleError(error) {
    var message = null;

    if (error.response) {
      var _error$response = error.response,
          data = _error$response.data,
          status = _error$response.status;

      switch (status) {
        case 504:
          {
            message = 'server_not_responding';
            break;
          }

        case 500:
          {
            message = 'fatal_error';
            break;
          }

        case 404:
          {
            message = 'resource_not_found';
            break;
          }

        case 403:
          {
            message = 'access_denied';
            break;
          }

        case 401:
          {
            message = 'need_to_be_logged';
            break;
          }

        default:
          {
            message = data && data.message ? data.message : null;
          }
      }
    } else if (!error.response && error.request) {
      message = 'unable_to_contact_api';
    } else if (!error.response && !error.request) {
      throw new Error('The request is malformed');
    }

    if (message && this.show_notifier) {
      notifications.error(t('error'), t(message));
    }
  },

  /**
   * Redirect to login if credentials are expired
   *
   * @private
   */
  _handleExpiredCredentials: function _handleExpiredCredentials() {
    notifications.warning(t('oops'), 'credentials_expired');
    security.deAuthenticate();
  }
};